import React from 'react'
import PropTypes from 'prop-types'

import V1 from './v1/V1Language'
import V2 from './v2/V2Language'

const Language = ({
  template = 'v1',
  intl: { changeLocale = () => {}, languageList = {} },
  ...rest
}) => {
  if (Object.keys(languageList).length === 0) return null

  const props = {
    changeLocale,
    languageList,
    ...rest,
  }

  switch (template) {
    case 'v1':
      return <V1 {...props} />
    case 'v2':
      return <V2 {...props} />
    default:
      return <V1 {...props} />
  }
}

Language.propTypes = {
  template: PropTypes.string,
  intl: PropTypes.shape({
    changeLocale: PropTypes.func,
    languageList: PropTypes.object,
  }),
}

export default Language
